<template>
  <!-- <van-pull-refresh class="wrapfollow" v-model="refreshing" @refresh="onRefresh"> -->
  <div>
    <van-list v-model="loading" :finished="finished" :finished-text="list.length ? '没有更多了' : ''" @load="onLoad">
      <template v-if="list.length">
        <item v-for="(item, index) in list" :key="index" :item="item"></item>
      </template>
      <van-empty v-if="list.length == 0 && finished" description="暂无信息" />
    </van-list>
    <rPage v-if="!refreshing"></rPage>
  </div>
  <!-- </van-pull-refresh> -->
</template>
<script>
import { getSubscribePost, userPartake } from '@/api/base';
import item from '../components/participatesItem.vue';
import rPage from '../components/rPage.vue';
export default {
  components: { item, rPage },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      page: {
        size: 10,
        current: 1,
      },
      list: [],
    };
  },
  created() {
    this.verification();
  },
  methods: {
    verification() {
      let userinfo = JSON.parse(window.localStorage.getItem('ycUserinfos'));
      if (userinfo == null) {
        console.log('为空');
        this.$router.replace('/yclogin');
        return;
      }
    },
    async onLoad() {
      // this.$toast.loading({
      //   duration: 0, // 持续展示 toast
      //   forbidClick: true,
      //   message: '...',
      // });
      let infos = JSON.parse(window.localStorage.getItem('ycUserinfos'));
      let obj = {
        "pageNo": this.page.current,
        userName: infos.userName,
        passWord: infos.passWord,
        uuid: infos.uuid,
      }
      userPartake(obj).then(res => {
        res.data.forumPageInfo.topics.map(item => {
          item.subscribe = true;
        });
        let tmpList = res.data.forumPageInfo.topics;
        let list = this.list || [];
        if (this.refreshing) {
          list = tmpList;
          this.refreshing = false;
        } else if (this.list.length < res.data.forumPageInfo.totalCount) {
          list = [...list, ...tmpList];
        } else {
          this.finished = true;
        }
        this.loading = false;
        this.list = list;
        this.page.current++;
        // this.$toast.clear();
      });
    },
    onRefresh() {
      this.list = [];
      this.refreshing = true;
      this.finished = false;
      this.page = { current: 1, size: 10 };
      this.onLoad();
    },
  },
};
</script>
<style scoped>
.wrapfollow {
  padding-bottom: 65px;
}
</style>
